export const REDUCER_KEY = "radios";
export const SET_RADIOS = "SET_RADIOS";
export const SET_RADIOS_SONGS = "SET_RADIOS_SONGS";
export const RESET_RADIOS = "RESET_RADIOS";
export const SET_LANG_RADIOS = "SET_LANG_RADIOS";
export const SET_RADIOS_DEFAULTS = "SET_RADIOS_DEFAULTS";
